<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('cities')"
          :description="$t('From Here You Can Control The List Of Cities')"
        />
        <indexTable
          :searchText="$t('Find The List Of Cities')"
          :emptyTableText="$t('There Is No List Of Cities')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="
            $checkRole('sales_payments_add') ||
            $checkRole('purchase_payments_add') ||
            $checkRole('expenses_add')
          "
          :cloumns="[
            {
              column: 'name',
              title: $t('The Name Of The City'),
              type: 'text',
              sort: true
            },
            {
              column: 'code',
              title: $t('CityCode'),
              type: 'text',
              sort: true
            },
            {
              column: 'price',
              title: $t('ShippingPrice'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('ShippingCost'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                {
                  name: 'edit',
                  role:
                    $checkRole('sales_payments_edit') ||
                    $checkRole('purchase_payments_edit') ||
                    $checkRole('expenses_edit')
                },
                {
                  name: 'delete',
                  role:
                    $user.admin ||
                    $checkRole('sales_payments_delete') ||
                    $checkRole('purchase_payments_delete') ||
                    $checkRole('expenses_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/cities'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
